<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div style="margin-right: 2%;" class="m-1">
			<div class="pt-2">
				<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-bottom">导出</el-button>
			</div>
			<div >
				<el-table class="mt-3" :data="tableData" style="width: 100%;" height="250" size="mini">
					<el-table-column align="center" prop="id" width="60" label="编号"></el-table-column>
					<el-table-column align="center" label="产品名称" width="160">
						<template slot-scope="scope">
							{{scope.row.cpid.cpmc}}
						</template>
					</el-table-column>
					<el-table-column align="center" label="产品编码">
						<template slot-scope="scope">
							{{scope.row.cpid.cpbm}}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="ggmc" label="规格名称"></el-table-column>
					<el-table-column align="center" prop="ggbm" label="规格编码"></el-table-column>
					<el-table-column align="center" prop="pch" label="批次号"></el-table-column>
					<el-table-column align="center" prop="kcsl" label="数量"></el-table-column>
					<el-table-column align="center" prop="dw" label="单位"></el-table-column>
					<el-table-column align="center" label="保质期">
						<template slot-scope="scope">
							{{scope.row.cpid.bzqts}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div style="" class="mt-3">
			<div ref="myCharta" style="width: 100%; height: 260px;"></div>
		</div>
	</div>
</template>

<script>
import * as vueEcharts from 'echarts';
let echarts = require('echarts');
export default {
	data() {
		return {
			myChart: null,
			tableData: [],
			tjname:[],
			tjnum:[],
			maxHeight: 0,
		};
	},
	mounted() {
		// 画统计图
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 90;
		});
		this.drawLine();
		
	},
	created() {
		this.axios.get('/admin/kcmxs', { token: true }).then(res => {
			let list = res.data.data;
			this.tableData = list
			var newdata = [];
			for ( let i = 0; i < 13; i++) {
				let data = list.filter(item => item.cpid.bzqts >= i * 30 && item.cpid.bzqts < (i + 1) * 30); // 过滤filter()
				if(data.length == 0){
					newdata.push(0);
				}else{
					let tjsl = data.map(i => {
						let kcsl = 0;
						return (kcsl += i.kcsl);
					});
					tjsl = tjsl.reduce((a, b) => a + b); // 求和reduce()
					newdata.push(tjsl);
				}
			}
			this.tjnum = newdata
		});
	},
	methods: {
		drawLine() {
			// 初始化echarts实例
			let myCharta = echarts.init(this.$refs.myCharta);
			var that = this;
			setTimeout(function() {
				// 配置参数
				myCharta.setOption({
					title: {
					    text: '库存保质期统计',
					  },
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					xAxis: [{
						type: 'category',
						data: ['30天', '60天', '90天', '120天', '150天', '180天', '210天', '240天', '270天', '300天', '330天', '360天', '1年以上'],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [
					    {
					      type: 'value'
					    }
					  ],
					series: [
						{
							name: '2022',
							type: 'bar',
							data: that.tjnum
						}
					]
				});
			}, 1000);
		}
	}
};
</script>

<style></style>
